import { LocaleKeys } from '../../../../locale/translation-types'

export enum StaffPositionEnum {
  AAT = 'AAT',
  ANIMATOR = 'ANIMATOR',
  TEACHER = 'TEACHER'
}

export const staffPositionEnumMapping: Record<StaffPositionEnum, LocaleKeys> = {
  [StaffPositionEnum.TEACHER]: 'staff.position.enum.TEACHER',
  [StaffPositionEnum.ANIMATOR]: 'staff.position.enum.ANIMATOR',
  [StaffPositionEnum.AAT]: 'staff.position.enum.AAT'
}

// Foreign OL spaces show their own English wording (Trello card 607)
export const olStaffPositionEnumMapping: Record<StaffPositionEnum, LocaleKeys> = {
  [StaffPositionEnum.TEACHER]: 'ol.staff.position.enum.TEACHER',
  [StaffPositionEnum.ANIMATOR]: 'ol.staff.position.enum.ANIMATOR',
  [StaffPositionEnum.AAT]: 'ol.staff.position.enum.AAT'
}
